import { getGenArtToken, getGenMintToken } from "../buildr/tokens";
import {
    useABI_ERC21_GenArtContract,
    useABI_ERC21_EyesFiClubContract,
    useABI_ERC21_EyesFiMintContract
} from '@/contacthelp/useContract.js';

import config from '@/config/config.js';


export function getArtcontract(library, account, chainID) {
    console.log('getArtcontract');
    const token = getGenArtToken(chainID);
    const GenArtContract = useABI_ERC21_EyesFiClubContract(library,
        account,
        token.address,
        true);
    return GenArtContract;

}

export function getEyesFiMintcontract(library, account, chainID) {
    console.log('getArtcontract');
    const token = getGenMintToken(chainID);
    const GenArtContract = useABI_ERC21_EyesFiMintContract(library,
        account,
        token.address,
        true);
    return GenArtContract;

}

export async function addProject({ library, account, chainID, projectName, artistAddress, pricePerTokenInWei, iscode }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const ProjectID = await Artcontract.nextProjectId();
    const tx = await Artcontract.addProject(projectName, artistAddress, pricePerTokenInWei, iscode);
    return {
        ProjectID,
        tx
    };

}

export async function toggleProjectPaused({ library, account, chainID, projectId }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const tx = await Artcontract.toggleProjectIsPaused(projectId);
    return tx;

}
export async function toggleProjectActive({ library, account, chainID, projectId }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const tx = await Artcontract.toggleProjectIsActive(projectId);
    return tx;
}

export async function updateProjectArtistAddress({ library, account, chainID, projectId, artistAddress }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const tx = await Artcontract.updateProjectArtistAddress(projectId, artistAddress);
    return tx;
}



export async function ProjectScriptInfo({ library, account, chainID, projectId }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.projectInfo(projectId);
    return info;

}

export async function ProjectStatus({ library, account, chainID, projectId }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.projectStatus(projectId);
    return info;

}

export async function ProjectDetails({ library, account, chainID, projectId }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.projectDetails(projectId);
    return info;

}

export async function ProjectTokenInfo({ library, account, chainID, projectId }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.projectTokenInfo(projectId);
    return info;

}

export async function updateProjectPricePerTokenInWei({ library, account, chainID, projectId, pricePerTokenInWei }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.updateProjectPricePerTokenInWei(projectId, pricePerTokenInWei);
    return info;

}

export async function updateProjectName({ library, account, chainID, projectId, projectName }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.updateProjectName(projectId, projectName);
    return info;

}


export async function updateProjectArtistName({ library, account, chainID, projectId, projectArtistName }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.updateProjectArtistName(projectId, projectArtistName);
    return info;

}



export async function updateProjectDescription({ library, account, chainID, projectId, projectDescription }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.updateProjectDescription(projectId, projectDescription);
    return info;

}

export async function updateProjectWebsite({ library, account, chainID, projectId, projectWebsite }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.updateProjectWebsite(projectId, projectWebsite);
    return info;

}

export async function updateProjectLicense({ library, account, chainID, projectId, projectLicense }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.updateProjectLicense(projectId, projectLicense);
    return info;

}

//铸造多少次
export async function updateProjectMaxInvocations({ library, account, chainID, projectId, maxInvocations }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.updateProjectMaxInvocations(projectId, maxInvocations);
    return info;

}

export async function addProjectScript({ library, account, chainID, projectId, script }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.addProjectScript(projectId, script);
    return info;

}
export async function updateProjectScript({ library, account, chainID, projectId, scriptId, script }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.updateProjectScript(projectId, scriptId, script);
    return info;

}

export async function removeProjectLastScript({ library, account, chainID, projectId }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.removeProjectLastScript(projectId);
    return info;

}

export async function projectScriptByIndex({ library, account, chainID, projectId, index }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.projectScriptByIndex(projectId, index);
    return info;

}


export async function purchase({ library, account, chainID, projectId, pricePerTokenInWei, isPassport, passportId }) {
    console.log({ library, account, chainID, projectId, pricePerTokenInWei, passportId });
    const Artcontract = getEyesFiMintcontract(library, account, chainID);

    console.log({ Artcontract });
    const info = await Artcontract.purchase(projectId, isPassport, passportId, {
        value: pricePerTokenInWei
    });
    return info;

}

export async function purchaseTo({ to, library, account, chainID, projectId, pricePerTokenInWei, isPassport, passportId }) {
    console.log({ to, library, account, chainID, projectId, pricePerTokenInWei, isPassport, passportId });
    const Artcontract = getEyesFiMintcontract(library, account, chainID);

    console.log({ Artcontract });
    const info = await Artcontract.purchaseTo(to, projectId, isPassport, passportId, {
        value: pricePerTokenInWei
    });
    return info;

}

export async function updateProjectBaseURI({ library, account, chainID, projectId }) {
    const Artcontract = getArtcontract(library, account, chainID);
    console.log(config);
    const api = config.baseApi[chainID];
    console.log(projectId, api);
    const tx = await Artcontract.updateProjectBaseURI(projectId, api);
    return tx;
}


// export async function projectURIInfo({ library, account, chainID, projectId }) {
//     const Artcontract = getArtcontract(library, account, chainID);
//     const info = await Artcontract.projectURIInfo(projectId);
//     return info;

// }



export async function toggleProjectPassportMint({ library, account, chainID, projectId }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.toggleProjectPassportMint(projectId);
    return info;
}

export async function updateProjectPassportProjectId({ library, account, chainID, projectId, passportProjectId }) {
    const Artcontract = getArtcontract(library, account, chainID);
    const info = await Artcontract.updateProjectPassportProjectId(projectId, passportProjectId);
    return info;
}